import { render } from "./ModalSelect.vue?vue&type=template&id=688510cb&scoped=true"
import script from "./ModalSelect.vue?vue&type=script&lang=js"
export * from "./ModalSelect.vue?vue&type=script&lang=js"

import "./ModalSelect.vue?vue&type=style&index=0&id=688510cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688510cb"]])

export default __exports__